import gql from 'graphql-tag';

export const GetBoardSettings = gql`
  query getBoardSettings($withLabels: Boolean!) {
    id
    boardSettings {
      id
      textlineChannels
    }
    labels @include(if: $withLabels) {
      id
      ...LabelDetailsFragment
    }
  }
`;
